import { render, staticRenderFns } from "./SocialPlatformLookup.vue?vue&type=template&id=7b1255d8&lang=pug"
import script from "./SocialPlatformLookup.vue?vue&type=script&lang=js"
export * from "./SocialPlatformLookup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports